import React from 'react';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Marcela T.',
  role: 'Abogada Civil - 12 años de ejercicio',
  city: 'Buenos Aires',
  stars: 5,
  text: 'Lo compré sin muchas expectativas, pero las plantillas me salvaron en un caso que tenía encima. Copié la estructura, la adapté y en 20 minutos tenía los puntos listos. Antes me llevaba toda la tarde.'
}, {
  name: 'Gonzalo R.',
  role: 'Abogado Penalista',
  city: 'Córdoba',
  stars: 4,
  text: 'Está muy bien armado. Las planillas editables son lo mejor, las uso para casi todos los casos. Le pongo 4 estrellas porque me gustaría que agreguen más modelos de penal, pero con lo que hay ya rinde bastante.'
}, {
  name: 'Soledad M.',
  role: 'Abogada Laboralista',
  city: 'Rosario',
  stars: 5,
  text: 'Yo venía redactando puntos periciales como podía, copiando de escritos viejos. Esto me ordenó completamente. Las plantillas son claras y las adapto en minutos. Se nota la diferencia en los escritos.'
}, {
  name: 'Fernando D.',
  role: 'Abogado - Daños y Perjuicios',
  city: 'Mendoza',
  stars: 4,
  text: 'Las planillas editables son muy prácticas, las tengo siempre abiertas cuando redacto. Algunos modelos son más útiles que otros dependiendo del fuero, pero en general es un material que uso todas las semanas.'
}, {
  name: 'Carolina P.',
  role: 'Abogada de Familia',
  city: 'Tucumán',
  stars: 5,
  text: 'Me lo recomendó una colega y no me arrepiento. Lo que más valoro son las estructuras base y las planillas — me ahorraron un montón de tiempo en un mes con mucha carga de trabajo. Muy recomendable.'
}];
export function Testimonials() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8" data-id="element-142">
      <div className="max-w-5xl mx-auto" data-id="element-143">
        <div className="text-center mb-16" data-id="element-144">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-145">
            Lo que dicen otros colegas
          </h2>
          <div className="w-24 h-1 bg-gold-500 mx-auto rounded-full" data-id="element-146"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-147">
          {testimonials.map((t, i) => <div key={i} className={`bg-slate-800/80 p-8 rounded-2xl border border-slate-700 relative shadow-xl ${i === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-148">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-slate-700 opacity-50" data-id="element-149" />
              <div className="flex gap-1 mb-6" data-id="element-150">
                {[...Array(5)].map((_, j) => <Star key={j} className={`w-5 h-5 ${j < t.stars ? 'fill-gold-500 text-gold-500' : 'fill-slate-600 text-slate-600'}`} data-id="element-151" />)}
              </div>
              <p className="text-slate-300 mb-8 italic text-base leading-relaxed" data-id="element-152">
                "{t.text}"
              </p>
              <div data-id="element-153">
                <p className="font-bold text-white text-lg" data-id="element-154">{t.name}</p>
                <p className="text-sm text-gold-400 mt-1" data-id="element-155">{t.role}</p>
                <p className="text-sm text-slate-500 mt-1" data-id="element-156">{t.city}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center mt-16" data-id="element-157">
          <a href="https://checkout.ebookpoint.shop/cart/59452963192913:1" className="inline-block w-full md:w-auto bg-[#dc2626] hover:bg-[#ef4444] text-white font-black text-xl px-12 py-5 rounded-lg shadow-[0_0_20px_rgba(220,38,38,0.4)] hover:shadow-[0_0_30px_rgba(220,38,38,0.6)] transition-all transform hover:-translate-y-1 uppercase tracking-wide border-b-4 border-[#991b1b]" data-id="element-158">
            QUIERO ESTOS RESULTADOS
          </a>
        </div>
      </div>
    </section>;
}